import { isAfter, isEqual } from 'date-fns';

import { makeCommaSeparatedString } from 'constants/helper';

export const NEW_GOAL_REPLACE_TOP_LEVEL_VALUE = 'NEW_GOAL_REPLACE_TOP_LEVEL_VALUE';
export const NEW_GOAL_UPDATE = 'NEW_GOAL_UPDATE';
export const NEW_GOAL_RESET_UPDATE = 'NEW_GOAL_RESET_UPDATE';

const isRequiredFilled = (task) => {
  if (
    task.editorState.getCurrentContent().hasText() &&
    task.editorState.getCurrentContent().getPlainText().trim().length > 0 &&
    task.target &&
    task.subObjective &&
    task.measure &&
    (isAfter(task.dueDate, task.startDate) || isEqual(task.dueDate, task.startDate))
  ) {
    return true;
  }
  return false;
};

const getErrorText = (task) => {
  const errorTexts = [];
  let dateValidationError = false;
  if (!task.subObjective) {
    errorTexts.push('objective');
  }
  if (!task.target) {
    errorTexts.push('a target');
  }
  if (!task.measure) {
    errorTexts.push('measure');
  }
  if (!isAfter(task.dueDate, task.startDate) && !isEqual(task.dueDate, task.startDate)) {
    dateValidationError = true;
  }
  const errorString = errorTexts.length ? `Please add ${makeCommaSeparatedString(errorTexts)} to save your goal.` : '';
  const dateValidationString = dateValidationError ? 'Start date cannot be greater than due date.' : '';

  const errorMessageSeparator = errorString && dateValidationString ? '\n' : '';
  // this separator decides whether the date validation message will be in next line or not.
  // In case both error message and date validation error exists, date validation error message has to be in next line

  return errorString + errorMessageSeparator + dateValidationString;
};

export function newGoalReducer(state, { type, payload }) {
  switch (type) {
    case NEW_GOAL_REPLACE_TOP_LEVEL_VALUE: {
      const updatedTask = { ...state.task, [payload.key]: payload.value };
      const canSave = isRequiredFilled(updatedTask);
      const errorText = getErrorText(updatedTask);
      return { task: updatedTask, canSave, errorText };
    }

    case NEW_GOAL_UPDATE: {
      const updatedTask = { ...state.task, ...payload };
      const canSave = isRequiredFilled(updatedTask);
      const errorText = getErrorText(updatedTask);

      return { task: updatedTask, canSave, errorText };
    }

    case NEW_GOAL_RESET_UPDATE: {
      const updatedTask = { ...payload };

      return { task: updatedTask, canSave: false, errorText: '' };
    }

    default:
      return state;
  }
}
